export default {
  pageTitle: {
    id: 'bo_seller.listing.product_create.page_title',
    defaultMessage: 'Create a product',
  },
  categoryChoiceStep: {
    id: 'bo_seller.listing.product_create.category_choice_step',
    defaultMessage: 'Choose product category',
  },
  productDetailsStep: {
    id: 'bo_seller.listing.product_create.product_details_step',
    defaultMessage: 'Create Product',
  },
  listingDetailsStep: {
    id: 'bo_seller.listing.product_create.listing_details_step',
    defaultMessage: 'Listing details',
  },
  productCategoryNotFound: {
    id: 'bo_seller.listing.product_create.product_category_not_found',
    defaultMessage: 'Product category not found',
  },
}
